import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getStorageList } from "./actions";

export const centraliseStorageEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = centraliseStorageEntityAdapter.getInitialState({});

export const centraliseStorageSlice = createSlice({
  name: "centraliseStorage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStorageList.fulfilled, (state, action) => {
      if (action.payload.success) {
        centraliseStorageEntityAdapter.setAll(state, action.payload.storages);
      }
    });
  },
});

export default centraliseStorageSlice.reducer;
